import React from 'react';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './sports.css'
import { Link } from 'react-router-dom';

const Sports = (props) => {
    const {  idLeague, strTeamBadge, strLeague, strSport} = props.sports;
    return (
        <div className="sports">
            <img src={strTeamBadge} alt=""/>
            <h1></h1>
            <h1>{strLeague}</h1>
            <p>Sports type: {strSport}</p>
            <button><Link to={`/sports/${idLeague}`}>Explore</Link> <FontAwesomeIcon icon={faArrowRight}/></button>
        </div>
    );
};

export default Sports;